import gql from 'graphql-tag';

export const UPDATE_AD_SETS_STATUS_MUTATION = gql`
  mutation UpdateAdSetsStatusMutation($ids: [ID!]!, $facebookState: AdSetsStateEnum!) {
    updateAdSetsStatus(ids: $ids, facebookState: $facebookState) {
      adSets {
        id
        facebookState
      }
      errors
    }
  }
`;
